import { TFunction } from "i18next";
import { IntlShape } from "react-intl";
import { InfoIcon } from "lucide-react";
import { formatNumberLocale } from "@/utils/helpers";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Button } from "@/components/ui/button";

interface ACPDefaultComponentProps {
  t: TFunction;
  intl: IntlShape;
  type: "default" | "currency";
  value: number;
  label: string;
}

function ACPDefaultComponent({ t, intl, type, value, label }: ACPDefaultComponentProps) {
  return (
    <div className="bg-slate-100 rounded-r-md h-full flex items-center justify-between p-2 text-xs">
      <span className="text-xs text-slate-500">{ type === "currency" ? formatNumberLocale(intl, value, "currency") : value}</span>
      <HoverCard>
        <HoverCardTrigger asChild>
          <Button variant="ghost" size="icon" className="ml-1 p-0 h-fit w-fit hover:cursor-help" type="button">
            <InfoIcon className="inline h-4 text-slate-400" />
          </Button>
        </HoverCardTrigger>
        <HoverCardContent side="left" className="max-w-[180px]">
          <p className="text-xs">
            {t("modals:editpermanentservicemodal.defaultvaluetooltip", { label })}
          </p>
        </HoverCardContent>
      </HoverCard>
    </div>
  );
}

export default ACPDefaultComponent;
